import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom" //
import { Row, Col, Card, CardBody } from "reactstrap"

import { connect } from "react-redux";

import { setBreadcrumbItems } from "../../store/actions";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import DataTableWithPopup from "components/longContentTable"
import { PAGEPATHS } from "../../components/Common/Constant"

const WebSecurity = (props) => {
    document.title = "Web Security";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [phttData, setPshttData] = useState({})
    const [sslyzeData, setSslyzeData] = useState({})
    const [contentSecurityPolicy, setContentSecurityPolicy] = useState('')

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Web Security", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Website Security', breadcrumbItems)
    })

    const fetchWBScans = async (url, table, setHook) => {
        try {
            const { data } = await axiosInstance.get(url)
            let valid
            if (table) {
                valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
            } else {
                valid = data.data["CSP Set for domain"]
            }
            setHook(valid)
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchWBScans(`${ApiNames.FETCH_CSP_SCAN}/${scanId}`, false, setContentSecurityPolicy)
        fetchWBScans(`${ApiNames.FETCH_PSHTT_SCAN}/${scanId}`, true, setPshttData)
        fetchWBScans(`${ApiNames.FETCH_SSLYZE_SCAN}/${scanId}`, true, setSslyzeData)
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card style={{ display: 'flex', }}>
                        <TableHeader scanName={'Content-Security-Policy'} scanId={null} />
                        <span
                            style={{
                                fontSize: '2em',
                                paddingLeft: '1em',
                                backgroundColor: contentSecurityPolicy ? 'rgb(202, 254, 206)' : 'rgb(254, 202, 202)',
                                color: contentSecurityPolicy ? '#00a70b' : '#a70000'
                            }}
                        >
                            {contentSecurityPolicy.toString()}
                        </span>
                    </Card>
                    <Card>
                        <TableHeader scanName={'Pshtt Scan'} scanId={scanId} />
                        <CardBody className="pshtt-table">
                            {phttData && phttData.rows && (
                                <DataTableWithPopup noBottomColumns thirdPartyData={phttData} />
                            )}
                        </CardBody>
                    </Card>
                    <Card>
                        <TableHeader scanName={'Sslyze Scan'} scanId={scanId} />
                        <CardBody className="sslyze-table">
                            {/* <MDBDataTable noBottomColumns responsive striped data={sslyzeData} /> */}
                            {sslyzeData && sslyzeData.rows && (
                                <DataTableWithPopup noBottomColumns thirdPartyData={sslyzeData} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(WebSecurity)